<template>
  <container>
    <div class="subpage__cnt col-xl-10 offset-xl-1 text-center">
      <SubpageGallery
        gallery-class="mt-0"
        v-if="cityDetails && cityDetails.images.length > 0"
        :gallery="cityDetails.images"
        :img-count="cityDetails.images.length > 5 ? 5 : 3"
      />
      <div class="about-slider" style="display:none">
        <swiper :options="swiperOption" v-if="cityDetails">
          <swiper-slide
            v-for="item in cityDetails.images"
            :key="item.id">
            <img :src="item.filename" alt=""/>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="subpage-text text-left" v-if="cityDetails" v-html="cityDetails.content"></div>
    </div>
  </container>
</template>

<script>
import SubpageGallery from '@/components/SubpageGallery'
import { mapGetters } from 'vuex'

export default {
  name: 'CityDetailAbout',
  components: {
    SubpageGallery
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        slidesPerGroup: 4,
        breakpoints: {
          640: {
            slidesPerView: 'auto',
            centeredSlides: false,
            slidesPerGroup: 1
          },
          320: {
            slidesPerView: 'auto',
            centeredSlides: false,
            slidesPerGroup: 1
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  methods: {
  },
  computed: {
    ...mapGetters(['cityDetails'])
  }
}
</script>

<style scoped>

</style>
